import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ThemeMode, AccentColor, Lang, Industry, ThemeState } from './types';

/**
 * Fresh visitors default to light + the ThaliOS orange accent + English.
 * redux-persist rehydrates over this for returning users. Keep the
 * static data-theme / data-color on <html> (index.html) in sync so the
 * first paint doesn't flash.
 */
const initialState: ThemeState = {
  mode: 'light',
  accent: 'orange',
  lang: 'en',
  industry: 'restaurant'
};

/** Default accent per business vertical. */
const industryAccent: Record<Industry, AccentColor> = {
  restaurant: 'orange',
  kirana: 'forest'
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleMode(state) {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    setMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
    },
    setAccent(state, action: PayloadAction<AccentColor>) {
      state.accent = action.payload;
    },
    setLang(state, action: PayloadAction<Lang>) {
      state.lang = action.payload;
    },
    /** Switch the tenant vertical — also snaps the accent to the vertical default. */
    setIndustry(state, action: PayloadAction<Industry>) {
      state.industry = action.payload;
      state.accent = industryAccent[action.payload];
    }
  }
});

export const { toggleMode, setMode, setAccent, setLang, setIndustry } = themeSlice.actions;
export default themeSlice.reducer;
